module.exports = "/_next/static/images/a11a55a18cab76cfdcc3507c91cb222e-footer-superfinanciera-4x.png";